import React from 'react';
import styled from 'styled-components';
import MainNavigation from '../components/MainNavigation';

//Assets
import background from '../assets/images/header.jpg';


const StyledComponent = styled.div`
.banner-general{
    position: relative;
    @media (max-width: 730px) {
        margin-top:74px;
    }
    .caption{
        position: absolute;
        width: 100%;
        height: 100%;
        top:0px;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        h1{
            margin-top:50px;
            color:#ffffff;
            text-align: center;
        }
    }
}

.atl-bedcrum{
    background-color: var(--color-azul);
    border-radius: 0;
    border: 1px solid var(--color-azul);
        border-top: 0px;
        border-bottom: 0px;
        z-index: 2;
    position: relative;
    & nav{
        
        & .breadcrumb{
            background-color: transparent;
            padding-left: 25px;
            & .breadcrumb-item{
                color:#ffffff;
                & a{
                    color:#ffffff;
                }
            }
        }
    }

}
.limit-bedcrum {
    margin-top: -24px;
}
.limit-bedcrum:after {
    content: "";
    width: 100%;
    right: 0px;
    top: 0px;
    height: 100%;
    position: absolute;
    background-color: var(--color-azul);
}

.atl-bedcrum {
    background-color: var(--color-azul);
    border-radius: 0;
    border: 1px solid var(--color-azul);
    border-top: 0px;
    border-bottom: 0px;
    z-index: 2;
    position: relative;
    min-height: 40px;
}
 
`

interface props{
    title:string
  }
  
export default  (props:props) => (
    <StyledComponent>
        <section className="section ">
            <div className="banner-general col-xs-12 p-0">
                <img src={background} className="img-fluid" alt="banner estadio" width="100%" />		
                <div className="caption"><h1></h1></div>				
            </div>
            <div className="col-12 limit-bedcrum">
                <div className="container">
                    <div className="atl-bedcrum">
                        <MainNavigation/>
                    </div>
                </div>
            </div>
            
            
        </section>

        
    </StyledComponent>
)